import { useHubspotFormsContext } from '@//app/[locale]/business/_contexts/HubspotFormsContext';
import { EventType } from '@/analytics/types';
import FooterCta from '@/app/components/FooterCta';
import { BUSINESS_PATHNAME } from '@/app/consts/pathnames';

import { HUBSPOT_SELECTION_MODAL_ID } from '../HubspotSelectionModal';

const BusinessHealth = () => {
  const { setActiveModal } = useHubspotFormsContext();

  return (
    <section className="pt-10 pb-14" data-cy="business-health">
      <FooterCta
        button={{
          'data-cy': 'business-footer-cta-button',
          label: 'business_health_action',
          onClick: () => {
            setActiveModal(HUBSPOT_SELECTION_MODAL_ID);

            void window.ouraAnalytics.track(EventType.LinkClicked, {
              cta: 'get_a_quote',
              location: 'body',
              path: BUSINESS_PATHNAME,
            });
          },
          variant: 'secondary-light',
        }}
        variant={{ sm: 'background', lg: 'background' }}
        title="business_health_title"
        image={{
          src: '/blue-sky/oura-for-business/business-health.png',
          localizedAlt: 'business_image_coffee_alt',
        }}
      />
    </section>
  );
};

export default BusinessHealth;
